import React from "react";

import styles from "./ErrorMessage.module.scss";

export const ErrorMessage = ({ text }) => {
  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container}>
        <p className={styles.errorMessage}>
          {text}
        </p>
      </div>
    </div>
  );
};
